import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

import { ValidateInput } from '../../utilities';

export default function CustomizedAutoComplete(props) {
    const {
        name,
        label,
        freeSolo,
        options,
        displayAllOption,
        required,
        value,
        onChange,
        error,
        schema
    } = props

    const [isValid, setIsValid] = useState(!error)
    const [selectOption, setSelectOption] = useState([])
    const [loading, setLoading] = useState(false)
    const [defaultValue, setDefaultValue] = useState({ id: "", label: "" })
    const [regexFormat, setRegexFormat] = useState(/^$/)

    const validateInput = (e, newValue) => {
        let validateValue = ""
        if (e.target.value !== 0) { // when select on option e.target.value = 0
            validateValue = e.target.value
        }
        else {
            validateValue = newValue.label
        }
        const valid = ValidateInput(schema, { [name]: validateValue })
        setIsValid(valid)
        onChange(e, newValue)
    }

    const renderOption = (e) => {
        validateInput(e, null)
        const matchRegex = generateValidationRegex(e.target.value)
        const regexFormat = RegExp(matchRegex, "i")
        setRegexFormat(regexFormat)
        if (displayAllOption) {
            return;
        }

        setLoading(true)
        if (e.target.value.length < 3) {
            setSelectOption([])
            setLoading(false)
        }

        if (e.target.value.length >= 3) {
            if (selectOption.length === 0) {
                let filterOptions = options.filter(option => regexFormat.test(option.label))
                filterOptions = filterOptions.map((o, index) => ({ label: o.label, id: o.id }))
                setSelectOption(filterOptions)
            }
        }
        setLoading(false)
    }

    const generateValidationRegex = (value) => {
        const strArr = value.split("")
        let regexStr = "^"

        let prevChar = ""
        for (let ch of strArr) {
            if (regexStr.length === 1) {
                regexStr += ch
                prevChar = ch
                continue
            }

            /* if previous is special character and current is not add ".*" */
            const isPreviousSpecialCharacter = (!checkForSpecialCharacter(prevChar) && checkForSpecialCharacter(ch))
            if (isPreviousSpecialCharacter) {
                regexStr += '.*'
                prevChar = ch
                continue
            }

            /* if previous charater is string and current character is string */
            const isPreviousTypeString = isNaN(ch) && isNaN(prevChar)
            if (isPreviousTypeString) {
                /* if special character continue */
                if (checkForSpecialCharacter(ch)) {
                    continue
                }
                regexStr += ch
                prevChar = ch
                continue
            }

            /* if previous charater is number and current character is number */
            const isPreviousTypeNumber = !isNaN(ch) && !isNaN(prevChar)
            if (isPreviousTypeNumber) {
                regexStr += ch
                prevChar = ch
                continue
            }

            regexStr += `.*${ch}`
            prevChar = ch
        }

        regexStr = regexStr.replace(".*.*", ".*")
        regexStr += ".*"
        return regexStr
    }

    const checkForSpecialCharacter = (str) => {
        var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return format.test(str)
    }

    const filterOptions = (options, state) => {
        options.sort(function(a,b) {return (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0);} );
        const displayOption = options.filter(o => regexFormat.test(o.label))
        if(displayOption.length === 0 && displayAllOption){
            return options
        }
        return displayOption
    };

    useEffect(() => {
        setIsValid(!error)
    }, [error])

    useEffect(() => {
        setDefaultValue(value ? { id: value, label: value } : { id: "", label: "" })
    }, [value])

    useEffect(() => {
        if (displayAllOption) {
            setSelectOption(options)
        }
    }, [])

    return <div className={`form-group form-element ${!isValid ? "error" : ""}`}>
        <div>
            <label htmlFor={name}>{label} {required ? <span className='text-danger'>*</span> : null}</label>
        </div>
        <div>
            <Autocomplete
                disablePortal
                freeSolo={freeSolo}
                id={name}
                options={selectOption}
                filterOptions={filterOptions}
                getOptionLabel={(option) => (option ? option.label : '')}
                renderOption={(props, option) => {
                    return (
                        <li {...props} key={option.id}>
                            {option.label}
                        </li>
                    );
                }}
                onChange={validateInput}
                renderInput={(params) => <TextField
                    name={name}
                    {...params}
                    placeholder={label}
                    className="form-control"
                    onChange={renderOption}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        )
                    }}
                />}
                sx={{ backgroundColor: "#fff", padding: "0" }}
                value={defaultValue}
            />
        </div>
    </div>;
}
